import { render, staticRenderFns } from "./AdminCohortDetailStudents.vue?vue&type=template&id=019f1f6a&"
import script from "./AdminCohortDetailStudents.vue?vue&type=script&lang=js&"
export * from "./AdminCohortDetailStudents.vue?vue&type=script&lang=js&"
import style0 from "./AdminCohortDetailStudents.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports